export const rowSectionConsts = {
    PERSONALIZED_CONTENT: {
        NAME: 'tailored_homepage',
    },
};
